<div *ngIf="sortedTableRows.length; else gridListingEmpty">
  <ag-grid-angular
    *ngIf="(isHandheld$ | async) === false"
    #estimateGrid
    style="width: 100%; height: 100%"
    class="ag-theme-frk"
    [rowData]="sortedTableRows"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [frameworkComponents]="frameworkComponents"
    [suppressPaginationPanel]="true"
    [suppressDragLeaveHidesColumns]="true"
    domLayout="autoHeight"
    [isExternalFilterPresent]="isExternalFilterPresent"
    [doesExternalFilterPass]="doesExternalFilterPass"
    overlayNoRowsTemplate="<p></p>"
    [context]="gridContext"
    [suppressRowHoverHighlight]="false"
    [suppressCellSelection]="false"
    [suppressRowTransform]="true"
    [ensureDomOrder]="true"
    [suppressColumnVirtualisation]="true"
    [enableCellTextSelection]="true"
    rowSelection="multiple"
    [suppressRowClickSelection]="true"
    (sortChanged)="onSortChanged($event)"
  >
  </ag-grid-angular>

  <div *ngIf="isHandheld$ | async">
    <ft-us-capital-gains-estimates-cards
      *ngFor="let item of gridListing"
      [cardData]="item"
      (cardSelected)="onRowSelected($event)"
    >
    </ft-us-capital-gains-estimates-cards>
  </div>
</div>

<!-- Display no result message, when no filter(s) matched. -->
<ng-template #gridListingEmpty>
  <p class="bold large">
    {{ "products.capgains-estimates-no-filter-result-message" | translate }}
  </p>
</ng-template>
